<template>
    <b-jumbotron v-if="show" bg-variant="white">
        <template #header>{{$t('pages.home.reset_mechanisms_title')}}</template>
        <template #lead>{{$t('pages.home.reset_mechanisms_explanation')}}</template>
        <p>{{$t('pages.home.reset_mechanisms_suggestion')}}</p>
        <b-button href="/u/account/private-email" variant="primary">
            <span class="text-white">
                <b-icon-envelope/>
                {{$t('pages.home.reset_mechanisms_set_email')}}
            </span>
        </b-button>
        <b-button href="/u/account/mobile-number" variant="primary">
            <span class="text-white">
                <b-icon-phone/>
                {{$t('pages.home.reset_mechanisms_set_cellphone')}}
            </span>
        </b-button>
    </b-jumbotron>
</template>

<script>
export default {
    name: "ResetMechanismsWarning",
    props: {
        rzaccount: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            show: false
        }
    },
    created: async function() {
        try {
            let response = await this.axios.get(this.$Bologna.secure_url(`/v1/reset-mechanisms/${this.rzaccount}/1`));
            this.show = !response?.data?.data?.has_reset_mechanism || false;
        } catch (e) {
            console.log(e)
        }
    }
}
</script>
